export default __webpack_public_path__ + "static/media/Line_(1)[1].9007ff96.svg";